<template>
  <component
    :is="tag"
    :class="[
      'tm-sticky-cell',
      `tm-sticky-cell--${position}`,
      {
        'tm-sticky-cell--with-shadow': withShadow,
        'tm-sticky-cell--selected': selected,
        'tm-sticky-cell--header': tag === 'th',
        [`tm-sticky-cell--alignment-${alignment?.direction}`]: alignment,
      },
    ]"
  >
    <div
      :class="[
        'tm-sticky-cell__wrapper',
        {
          'tm-sticky-cell__wrapper--selected': selected,
          [`tm-sticky-cell__wrapper--alignment-${alignment?.direction}`]: alignment,
        },
      ]"
    >
      <slot />
    </div>
  </component>
</template>

<script setup lang="ts">
import type { Nullable } from '@/types'
import type { TableAlignment } from '@/services/tables/types'

withDefaults(
  defineProps<{
    tag?: 'td' | 'th'
    position?: 'left' | 'right'
    selected?: boolean
    alignment?: Nullable<TableAlignment>
    withShadow: boolean
  }>(),
  {
    tag: 'td',
    position: 'right',
    selected: false,
  },
)
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.tm-sticky-cell {
  position: sticky !important;
  z-index: 1;
  background-color: $white;

  &--left {
    left: 0;
  }

  &--right {
    right: 0;
  }

  &--with-shadow {
    @include table-sticky-cell-shadow;
  }

  &--header {
    background-color: var(--tm-table-header-bg, $shade);
  }

  &--transparent {
    background: transparent !important;
  }

  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;

    &--alignment-top {
      align-items: flex-start;
    }

    &--alignment-initial {
      align-items: initial;
    }

    &--alignment-bottom {
      align-items: flex-end;
    }

    &--selected {
      background: $background-blue !important;
    }
  }

  &--alignment-top {
    vertical-align: top;
    padding: calc((var(--tm-table-row-height) - 28px) / 2) 0 calc((var(--tm-table-row-height) - 28px) / 2 - 1px) 0 !important;
  }

  &--alignment-initial {
    vertical-align: initial;
  }

  &--alignment-bottom {
    vertical-align: bottom;
    padding: calc((var(--tm-table-row-height) - 28px) / 2) 0 calc((var(--tm-table-row-height) - 28px) / 2 - 1px) 0 !important;
  }
}
</style>
